module.exports = __webpack_public_path__ + "img/spinner.2a791013.svg";